import { createFileRoute } from "@tanstack/react-router"
import PdfEditorPage from "@/app/export/pdf/page"

export const Route = createFileRoute("/export/pdf")({
  component: PdfEditorPage,
})
